/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EntityLockTokenDto,
  EntityLockTokenInputDto,
  ProblemDetails,
} from '../models/index';
import {
    EntityLockTokenDtoFromJSON,
    EntityLockTokenDtoToJSON,
    EntityLockTokenInputDtoFromJSON,
    EntityLockTokenInputDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteTokenRequest {
    tokenId: string;
}

export interface RequestTokenRequest {
    entityLockTokenInputDto?: EntityLockTokenInputDto;
}

export interface UpdateTokenRequest {
    tokenId: string;
}

/**
 * 
 */
export class EntityLockTokensApi extends runtime.BaseAPI {

    /**
     */
    async deleteTokenRaw(requestParameters: DeleteTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.tokenId === null || requestParameters.tokenId === undefined) {
            throw new runtime.RequiredError('tokenId','Required parameter requestParameters.tokenId was null or undefined when calling deleteToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/entity-lock-tokens/{tokenId}`.replace(`{${"tokenId"}}`, encodeURIComponent(String(requestParameters.tokenId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteToken(requestParameters: DeleteTokenRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteTokenRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async requestTokenRaw(requestParameters: RequestTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EntityLockTokenDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/entity-lock-tokens`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EntityLockTokenInputDtoToJSON(requestParameters.entityLockTokenInputDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => EntityLockTokenDtoFromJSON(jsonValue));
    }

    /**
     */
    async requestToken(requestParameters: RequestTokenRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.requestTokenRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<EntityLockTokenDto>(response, errorHandlers);
    }

    /**
     */
    async updateTokenRaw(requestParameters: UpdateTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EntityLockTokenDto>> {
        if (requestParameters.tokenId === null || requestParameters.tokenId === undefined) {
            throw new runtime.RequiredError('tokenId','Required parameter requestParameters.tokenId was null or undefined when calling updateToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/entity-lock-tokens/{tokenId}`.replace(`{${"tokenId"}}`, encodeURIComponent(String(requestParameters.tokenId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => EntityLockTokenDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateToken(requestParameters: UpdateTokenRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateTokenRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<EntityLockTokenDto>(response, errorHandlers);
    }

}
